import Spinner from './Spinner'

import { CenteredContainer, SpinnerContainerProps } from './styles'

function SpinnerCentered(props: SpinnerContainerProps) {
  return (
    <CenteredContainer {...props}>
      <Spinner />
    </CenteredContainer>
  )
}

export default SpinnerCentered
